export default {
    RAISE: 'RAISE',
    LOWER: 'LOWER',
    KEEP: 'KEEP',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
};
